import DealtService from "@/services/dealt";
import ErrorHandler from "../../../tools/errorHandler";
import * as types from "./mutationTypes";
import { i18n } from '@/boot/i18n'

const DealtServiceEntity = new DealtService();

export default {
  initState({ rootState }, loopUUID) {
    DealtServiceEntity.setOrganizationUUID(rootState.organization.organization.uuid);
    DealtServiceEntity.setLoopUUID(loopUUID);
  },
  clearState({ commit, dispatch }) {
    commit(types.CLEAR_DEALTS_STATE);
    commit(types.CLEAR_DEALT);
    dispatch("metadata/clearMetadatas", null, { root: true });
  },
  async getDealts({ dispatch, commit }, params) {
    commit(types.SET_QUERY_PARAMS, { params });
    await dispatch("getAll");
  },
  async getAll({ dispatch, commit, state }) {
    try {
      const { queryParams } = state;
      const { data: responseData } = (await DealtServiceEntity.getAll({ ...queryParams })) || {};
      const { data } = responseData || {};
      // const { dealts = [], total_rows } = data || {};

      const dealts = data;

      if (!data.dealts) {
        dealts.dealts = [];
      }

      commit(types.SET_DEALTS, { dealts });
      // commit(types.SET_QUERY_PARAMS, {
      //   params: {
      //     rowsNumber: total_rows || 0
      //   }
      // });

      let total = dealts.total_dealts;
      const statusFilter = queryParams["filter.status.equal"];
      if (statusFilter > 0) {
        if (statusFilter == 3) total = dealts.total_dealts_finished;
        else if (statusFilter === 2) total = dealts.total_dealts_ongoing;
        else total = dealts.total_dealts_open;
      }

      commit(types.SET_QUERY_PARAMS, {
        params: {
          rowsNumber: total
        }
      });
    } catch (error) {
      dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  async getOne({ dispatch, commit }, dealtUUID) {
    try {
      const { data: responseData } = await DealtServiceEntity.getOne(dealtUUID);
      const { data } = responseData || {};
      const dealt = data || {};
      commit(types.SET_DEALT, { dealt });
    } catch (error) {
      dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  async createEvent({ dispatch, state, commit }, event) {
    try {
      const { data: responseData } = await DealtServiceEntity.createDealtEvent(state.dealt.uuid, event);
      const { data } = responseData || {};
      const dealt = data || {};
      commit(types.SET_DEALT, { dealt });
      dispatch("ui/showToastSuccess", i18n.tc("loop.messages.generic_update_success"), { root: true });
    } catch (error) {
      dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  setQueryParams({ commit }, queryParams) {
    commit(types.SET_QUERY_PARAMS, { params: queryParams });
  },
  setVisibleColumns({ commit }, metadataSelected) {
    commit(types.SET_VISIBLECOLUMNS, { metadataSelected });
  }
};
